import React from 'react';
import { stencilFrameType as tooltip } from 'pu-data/Tooltips';
import TextComponent from './TextComponent';

const StencilFrameType = (props) => {
  const name = 'frame_type';
  const {
    label, inputId, required, groupName, children, onChangeParameter, errorMessage,
  } = props
  const onChange = (e) => onChangeParameter(name, e.target.value);
  const { parameters } = props
  return (
    <TextComponent
      label={label}
      name={name}
      inputId={inputId}
      value={parameters[name] || ''}
      required={required}
      onChange={onChange}
      tooltip={tooltip}
      ignoreOnQuote
      groupName={groupName}
      errorMessage={errorMessage}>
      {children}
    </TextComponent>
  );
};

StencilFrameType.defaultProps = {
  required: true,
  inputId: 'frame-type',
  label: 'Frame Type',
};

export default StencilFrameType;
